export const TX_SET_WITH_DRAW_ADDRESS_SET = 'TX_SET_WITH_DRAW_ADDRESS_SET';
export const TX_SET_WITH_DRAW_ADDRESS_MEMO_SET = 'TX_SET_WITH_DRAW_ADDRESS_MEMO_SET';
export const TX_SET_WITH_DRAW_ADDRESS_MODAL_SHOW = 'TX_SET_WITH_DRAW_ADDRESS_MODAL_SHOW';
export const TX_SET_WITH_DRAW_ADDRESS_MODAL_HIDE = 'TX_SET_WITH_DRAW_ADDRESS_MODAL_HIDE';
export const SET_PREVIOUS_MODAL_NAME = 'SET_PREVIOUS_MODAL_NAME';
